import { render, staticRenderFns } from "./CategoryCollectionSidebar.vue?vue&type=template&id=dd5114ea&scoped=true&"
import script from "./CategoryCollectionSidebar.vue?vue&type=script&lang=ts&"
export * from "./CategoryCollectionSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryCollectionSidebar.vue?vue&type=style&index=0&id=dd5114ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5114ea",
  null
  
)

export default component.exports